var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('IconRepair',{attrs:{"size":"100","color":"#14142B"}}),_c('main',{domProps:{"textContent":_vm._s(_vm.text)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }